// src/constants/terminalConstants.js

export const FARE_TYPES = {
  KNOWN_FARE: [
    // "DEBT_RECOVERY_MERCHANT_INITIATED",
    // "DEBT_RECOVERY_PAYER_INITIATED",
    // "DEBT_RECOVERY_TAP_INITIATED",
    // "FARE_DEFERRED_AUTHORIZATION",
    // "FARE_REAL_TIME_AUTHORIZATION",
    "HARDPOS",
    "SOFTPOS",
    "ATM",
    "QR_MERCHANT"
  ],

  TRANSPORT_MODE: [
    "CABLE_CAR",
    "COACH",
    "COMMUTER_TRAIN",
    "EXPRESS_COMMUTER_TRAIN",
    "FUNICULAR_TRAIN",
    "HIGH_SPEED_TRAIN",
    "INTERURBAN_BUS",
    "INTER_CITY",
    "LIGHT_TRAIN_MASS_TRANSIT",
    "LOCOMOTIVE",
    "OTHER",
    "PARA_TRANSIT",
    "PARKING",
    "POWERED_MOTOR_VEHICLE",
    "REGIONAL_TRAIN",
    "RURAL_BUS",
    "SELF_DRIVE_VEHICLE",
    "TAXI",
    "TOLL",
    "TRAILER",
    "TRAIN",
    "URBAN_BUS",
    "WATER_BORNE_VEHICLE",
  ],
};

export const POSTERMINAL = {
  ATTENDED: [
    "ATTENDED",
    "SEMI_ATTENDED",
    "UNATTENDED",
    "UNKNOWN_OR_UNSPECIFIED",
  ],

  CARDHOLDER_ACTIVATED: [
    "AUTOMATED_DISPENSING_MACHINE_WITH_PIN",
    "ELECTRONIC_COMMERCE",
    "IN_FLIGHT_COMMERCE",
    "LIMITED_AMOUNT_TERMINAL",
    "MPOS_ACCEPTANCE_DEVICE",
    "NOT_CARDHOLDER_ACTIVATED",
    "SELF_SERVICE_TERMINAL",
    "TRANSPONDER_TRANSACTION",
  ],

  CARD_PRESENCE_CAPABILITY: [
    "CARD_NOT_PRESENT",
    "CARD_PRESENT",
    "CARD_PRESENT_AND_CARD_NOT_PRESENT",
  ],

  INPUT_CAPABILITY: [
    "BARCODE",
    "CHIP",
    "CHIP_AND_KEY_ENTRY_AND_MAGNETIC_STRIPE",
    "CHIP_AND_KEY_ENTRY_AND_MAGNETIC_STRIPE_AND_RFID",
    "CHIP_AND_MAGNETIC_STRIPE",
    "CONTACTLESS_CHIP",
    "CONTACTLESS_MAGNETIC_STRIPE",
    "CONTACTLESS_OR_MAGNETIC_STRIPE",
    "KEY_ENTRY",
    "KEY_ENTRY_AND_MAGNETIC_STRIPE",
    "MAGNETIC_STRIPE",
    "UNKNOWN",
    "VOICE_AUDIO_RESPONSE",
  ],

  LOCATION: [
    "MERCHANT_TERMINAL_OFF_PREMISES",
    "MERCHANT_TERMINAL_ON_PREMISES",
    "NO_TERMINAL_VOICE_OR_AUDIO_RESPONSE",
    "PAYER_TERMINAL_OFF_PREMISES",
    "PAYER_TERMINAL_ON_PREMISES",
  ],

  ONLINE_REASON_CODE: [
    "CHIP_APPLICATION_DATA_FILE_ERROR",
    "CHIP_COMMON_DATA_FILE_ERROR",
    "FORCED_BY_CHIP",
    "FORCED_BY_ISSUER",
    "FORCED_BY_MERCHANT",
    "FORCED_BY_TERMINAL",
    "MERCHANT_SUSPICIOUS",
    "OVER_FLOOR_LIMIT",
    "RANDOM_SELECTION_BY_TERMINAL",
    "UNABLE_TO_PROCESS_CHIP",
  ],

  PAN_ENTRY_MODE: [
    "BARCODE_READER",
    "CHIP",
    "CHIP_FALLBACK",
    "CONTACTLESS",
    "ECOMMERCE",
    "KEYED",
    "MOBILE_COMMERCE",
    "OPTICAL_CHARACTER_READER",
    "RFID_CHIP",
    "RFID_STRIPE",
    "SWIPE",
    "SWIPE_WITH_SIGNATURE",
    "UNKNOWN",
    "VOICE_AUTHORIZATION",
    "VOICE_RESPONSE",
  ],

  PIN_ENTRY_CAPABILITY: [
    "OFFLINE_PIN_ONLY",
    "PIN_NOT_SUPPORTED",
    "PIN_PAD_INOPERATIVE",
    "PIN_SUPPORTED",
    "SOFTWARE_ONLINE_PIN_ONLY",
    "UNKNOWN",
  ],
  TRANSACTION_TYPE: [
    { label: "Sales", value: "SALES" },
    { label: "Void", value: "VOID" },
    { label: "Refund", value: "REFUND" },
    { label: "Settlement", value: "SETTLEMENT" },
    { label: "Pre Auth", value: "PRE AUTH" },
    { label: "Pre Auth Completion", value: "PRE AUTH COMPLETION" },
    { label: "Tip", value: "TIP" },
    { label: "Tip Completion", value: "TIP COMPLETION" },
    { label: "Sales Adjust", value: "SALES ADJUST" },
    { label: "Balance Inquiry", value: "BALANCE INQUIRY" },
    { label: "QR Payments", value: "QR PAYMENTS" },
    { label: "Kisan Card", value: "KISAN CARD" },
   
   
  ],
};
export const MERCHANT_TYPES = {
  KNOWN_TYPES: ["POS", "SOFTPOS", "TRANSIT_ALL"],
};
export const MCC_LIST = [
  {
    "code": "742",
    "name": "Veterinary services"
  },
  {
    "code": "763",
    "name": "Agricultural co-operative"
  },
  {
    "code": "780",
    "name": "Landscaping and horticultural services"
  },
  {
    "code": "1520",
    "name": "General contractors - residential & commercial"
  },
  {
    "code": "1711",
    "name": "Heating, plumbing, and air conditioning contractors"
  },
  {
    "code": "1731",
    "name": "Electrical contractors"
  },
  {
    "code": "1740",
    "name": "Masonry, stonework, tile setting, plastering & insulation contractors"
  },
  {
    "code": "1750",
    "name": "Carpentry contractors"
  },
  {
    "code": "1761",
    "name": "Roofing and siding contractors"
  },
  {
    "code": "1771",
    "name": "Concrete work contractors"
  },
  {
    "code": "1799",
    "name": "Special trade contractors (not elsewhere classified)"
  },
  {
    "code": "2741",
    "name": "Miscellaneous publishing and printing"
  },
  {
    "code": "2791",
    "name": "Typesetting, plate making, and related services"
  },
  {
    "code": "2842",
    "name": "Specialty cleaning, polishing, & sanitation preparations"
  },
  {
    "code": "3357",
    "name": "Hertz"
  },
  {
    "code": "3359",
    "name": "Payless car rental"
  },
  {
    "code": "3366",
    "name": "Budget rent-a-car"
  },
  {
    "code": "3370",
    "name": "Rent-a-wreck"
  },
  {
    "code": "3385",
    "name": "Tropical rent-a-car"
  },
  {
    "code": "3389",
    "name": "Avis rent-a-car"
  },
  {
    "code": "3390",
    "name": "Dollar rent-a-car"
  },
  {
    "code": "3393",
    "name": "National car rental"
  },
  {
    "code": "3395",
    "name": "Thrifty car rental"
  },
  {
    "code": "3398",
    "name": "Econo-car rent-a-car"
  },
  {
    "code": "3501",
    "name": "Holiday Inns"
  },
  {
    "code": "3502",
    "name": "Best Western"
  },
  {
    "code": "3503",
    "name": "Sheraton"
  },
  {
    "code": "3504",
    "name": "Hilton"
  },
  {
    "code": "3506",
    "name": "Golden Tulip"
  },
  {
    "code": "3507",
    "name": "Friendship Inns"
  },
  {
    "code": "3508",
    "name": "Quality International"
  },
  {
    "code": "3509",
    "name": "Marriott"
  },
  {
    "code": "3510",
    "name": "Days Inns"
  },
  {
    "code": "3512",
    "name": "Intercontinental"
  },
  {
    "code": "3515",
    "name": "Rodeway Inns"
  },
  {
    "code": "3516",
    "name": "La Quinta Motor Inns"
  },
  {
    "code": "3517",
    "name": "Americana Hotels"
  },
  {
    "code": "3520",
    "name": "Meridien"
  },
  {
    "code": "3527",
    "name": "Downtowner Passport"
  },
  {
    "code": "3528",
    "name": "Red Lion"
  },
  {
    "code": "3535",
    "name": "Hilton International"
  },
  {
    "code": "3536",
    "name": "AMFAC Hotels"
  },
  {
    "code": "3539",
    "name": "Summerfield Suites Hotels"
  },
  {
    "code": "3542",
    "name": "Royal Hotels"
  },
  {
    "code": "3543",
    "name": "Four Seasons Hotels"
  },
  {
    "code": "3546",
    "name": "Hotel Sierra"
  },
  {
    "code": "3550",
    "name": "Regal 8 Inns"
  },
  {
    "code": "3562",
    "name": "Comfort Hotel International"
  },
  {
    "code": "3565",
    "name": "Relax Inns"
  },
  {
    "code": "3573",
    "name": "Sandman Hotels"
  },
  {
    "code": "3574",
    "name": "Venture Inn"
  },
  {
    "code": "3575",
    "name": "Vagabond Hotels"
  },
  {
    "code": "3579",
    "name": "Hotel Mercure"
  },
  {
    "code": "3588",
    "name": "Helmsley Hotels"
  },
  {
    "code": "3590",
    "name": "Fairmont Hotels Corporation"
  },
  {
    "code": "3591",
    "name": "Sonesta International Hotels"
  },
  {
    "code": "3592",
    "name": "Omni International"
  },
  {
    "code": "3595",
    "name": "Hospitality Inns"
  },
  {
    "code": "3615",
    "name": "Travelodge Motels"
  },
  {
    "code": "3631",
    "name": "Sleep Inn"
  },
  {
    "code": "3637",
    "name": "Ramada Inns"
  },
  {
    "code": "3638",
    "name": "Howard Johnson"
  },
  {
    "code": "3641",
    "name": "Sofitel Hotels"
  },
  {
    "code": "3644",
    "name": "Econo-Travel Motor Hotel"
  },
  {
    "code": "3648",
    "name": "De Vere Hotels"
  },
  {
    "code": "3649",
    "name": "Radisson"
  },
  {
    "code": "3650",
    "name": "Red Roof Inns"
  },
  {
    "code": "3652",
    "name": "Embassy Hotels"
  },
  {
    "code": "3654",
    "name": "Loews Hotels"
  },
  {
    "code": "3660",
    "name": "Knights Inns"
  },
  {
    "code": "3665",
    "name": "Hampton Inns"
  },
  {
    "code": "3681",
    "name": "Adams Mark"
  },
  {
    "code": "3684",
    "name": "Budget Host Inn"
  },
  {
    "code": "3685",
    "name": "Budgetel"
  },
  {
    "code": "3687",
    "name": "Clarion Hotel"
  },
  {
    "code": "3690",
    "name": "Courtyard by Marriott"
  },
  {
    "code": "3692",
    "name": "Doubletree"
  },
  {
    "code": "3693",
    "name": "Drury Inn"
  },
  {
    "code": "3694",
    "name": "Economy Inns of America"
  },
  {
    "code": "3695",
    "name": "Embassy Suites"
  },
  {
    "code": "3699",
    "name": "Midway Motor Lodge"
  },
  {
    "code": "3700",
    "name": "Motel 6"
  },
  {
    "code": "3703",
    "name": "Residence Inns"
  },
  {
    "code": "3704",
    "name": "Royce Hotel"
  },
  {
    "code": "3705",
    "name": "Sandman Inns"
  },
  {
    "code": "3706",
    "name": "Shilo inns"
  },
  {
    "code": "3707",
    "name": "Shoney's Inns"
  },
  {
    "code": "3709",
    "name": "Super 8 Motels"
  },
  {
    "code": "3715",
    "name": "Fairfield Inns"
  },
  {
    "code": "3716",
    "name": "Carlton Hotels"
  },
  {
    "code": "3722",
    "name": "Wyndham"
  },
  {
    "code": "3731",
    "name": "Harrah's Hotels and Casinos"
  },
  {
    "code": "3738",
    "name": "Tropicana Resort and Casino"
  },
  {
    "code": "3742",
    "name": "Club Med"
  },
  {
    "code": "3747",
    "name": "Club Corp / Club Resorts"
  },
  {
    "code": "3748",
    "name": "Wellesley Inns"
  },
  {
    "code": "3750",
    "name": "Crowne Plaza Hotels"
  },
  {
    "code": "3773",
    "name": "The Venetian Resort Hotel Casino"
  },
  {
    "code": "3783",
    "name": "Town and Country Resort"
  },
  {
    "code": "4011",
    "name": "Freight Railways"
  },
  {
    "code": "4111",
    "name": "Local passenger transportation"
  },
  {
    "code": "4112",
    "name": "Passenger railways"
  },
  {
    "code": "4119",
    "name": "Ambulance services"
  },
  {
    "code": "4121",
    "name": "Taxicabs and limousines"
  },
  {
    "code": "4131",
    "name": "Bus lines"
  },
  {
    "code": "4214",
    "name": "Motor freight carriers and trucking"
  },
  {
    "code": "4215",
    "name": "Courier services"
  },
  {
    "code": "4225",
    "name": "Public warehousing and storage"
  },
  {
    "code": "4411",
    "name": "Steamship and cruise lines"
  },
  {
    "code": "4457",
    "name": "Boat rentals and leasing"
  },
  {
    "code": "4468",
    "name": "Marinas, marine service, and supplies"
  },
  {
    "code": "4511",
    "name": "Airlines and air carriers (not elsewhere classified)"
  },
  {
    "code": "4582",
    "name": "Airports, flying fields, and airport terminals"
  },
  {
    "code": "4722",
    "name": "Travel agencies and tour operators"
  },
  {
    "code": "4784",
    "name": "Toll and bridge fees"
  },
  {
    "code": "4789",
    "name": "Transportation services (not elsewhere classified)"
  },
  {
    "code": "4812",
    "name": "Telecommunication equipment and telephone sales"
  },
  {
    "code": "4814",
    "name": "Telecommunication service"
  },
  {
    "code": "4815",
    "name": "Visaphone"
  },
  {
    "code": "4816",
    "name": "Computer network / information services"
  },
  {
    "code": "4821",
    "name": "Telegraph services"
  },
  {
    "code": "4829",
    "name": "Wire Transfer Money Orders (WTMOS)"
  },
  {
    "code": "4899",
    "name": "Cable, satellite and other pay television, and radio services"
  },
  {
    "code": "4900",
    "name": "Utilities - electric, gas, water, sanitary"
  },
  {
    "code": "5013",
    "name": "Motor vehicle supplies and new parts"
  },
  {
    "code": "5021",
    "name": "Office and commercial furniture"
  },
  {
    "code": "5039",
    "name": "Construction materials (not elsewhere classified)"
  },
  {
    "code": "5044",
    "name": "Photographic, photocopy, microfilm equipment and supplies"
  },
  {
    "code": "5045",
    "name": "Computers and computer peripheral equipment and services"
  },
  {
    "code": "5046",
    "name": "Commercial equipment (not elsewhere classified)"
  },
  {
    "code": "5047",
    "name": "Medical, dental, ophthalmic, and hospital equipment and supplies"
  },
  {
    "code": "5051",
    "name": "Metal service centers and offices"
  },
  {
    "code": "5065",
    "name": "Electrical parts and equipment"
  },
  {
    "code": "5072",
    "name": "Hardware, equipment and supplies"
  },
  {
    "code": "5074",
    "name": "Plumbing and heating equipment and supplies"
  },
  {
    "code": "5085",
    "name": "Industrial supplies (not elsewhere classified)"
  },
  {
    "code": "5094",
    "name": "Precious stones, metals, watches, and jewelry"
  },
  {
    "code": "5099",
    "name": "Durable goods (not elsewhere classified)"
  },
  {
    "code": "5111",
    "name": "Stationery, office supplies, printing, and writing paper"
  },
  {
    "code": "5122",
    "name": "Drugs, drug proprietaries, and druggist sundries"
  },
  {
    "code": "5131",
    "name": "Piece goods, notions, and other dry goods"
  },
  {
    "code": "5137",
    "name": "Men's, women's, and children's uniforms, and commercial clothing"
  },
  {
    "code": "5139",
    "name": "Commercial footwear"
  },
  {
    "code": "5169",
    "name": "Chemicals and allied products (not elsewhere classified)"
  },
  {
    "code": "5172",
    "name": "Petroleum and petroleum products"
  },
  {
    "code": "5192",
    "name": "Books, periodicals, and newspapers"
  },
  {
    "code": "5193",
    "name": "Florist supplies, nursery stock, and flowers"
  },
  {
    "code": "5198",
    "name": "Paint, varnishes, and supplies"
  },
  {
    "code": "5199",
    "name": "Nondurable goods (not elsewhere classified)"
  },
  {
    "code": "5200",
    "name": "Home supply warehouse stores"
  },
  {
    "code": "5211",
    "name": "Lumber and building materials stores"
  },
  {
    "code": "5231",
    "name": "Glass, paint, and wallpaper stores"
  },
  {
    "code": "5251",
    "name": "Hardware stores"
  },
  {
    "code": "5261",
    "name": "Nurseries and lawn and garden supply stores"
  },
  {
    "code": "5271",
    "name": "Mobile home dealers"
  },
  {
    "code": "5300",
    "name": "Wholesale clubs"
  },
  {
    "code": "5309",
    "name": "Duty free stores"
  },
  {
    "code": "5310",
    "name": "Discount stores"
  },
  {
    "code": "5311",
    "name": "Department stores"
  },
  {
    "code": "5331",
    "name": "Variety stores"
  },
  {
    "code": "5399",
    "name": "Miscellaneous general merchandise"
  },
  {
    "code": "5411",
    "name": "Grocery stores and supermarkets"
  },
  {
    "code": "5422",
    "name": "Freezer and locker meat provisioners"
  },
  {
    "code": "5441",
    "name": "Candy, nut, and confectionery stores"
  },
  {
    "code": "5451",
    "name": "Dairy products stores"
  },
  {
    "code": "5462",
    "name": "Bakeries"
  },
  {
    "code": "5499",
    "name": "Miscellaneous food stores - convenience stores and specialty markets"
  },
  {
    "code": "5511",
    "name": "Car and truck dealers (new and used) sales, service, repairs, parts, and leasing"
  },
  {
    "code": "5521",
    "name": "Car and truck dealers (used only) sales, service, repairs, parts, and leasing"
  },
  {
    "code": "5531",
    "name": "Auto and home supply stores (no longer valid MCC)"
  },
  {
    "code": "5532",
    "name": "Automotive tire stores"
  },
  {
    "code": "5533",
    "name": "Automotive parts and accessories stores"
  },
  {
    "code": "5541",
    "name": "Service stations"
  },
  {
    "code": "5542",
    "name": "Automated fuel dispensers"
  },
  {
    "code": "5551",
    "name": "Boat dealers"
  },
  {
    "code": "5561",
    "name": "Camper, recreational and utility trailer dealers"
  },
  {
    "code": "5571",
    "name": "Motorcycle shops and dealers"
  },
  {
    "code": "5592",
    "name": "Motor homes dealers"
  },
  {
    "code": "5598",
    "name": "Snowmobile dealers"
  },
  {
    "code": "5599",
    "name": "Miscellaneous automotive, aircraft, and farm equipment dealers (not elsewhere classified)"
  },
  {
    "code": "5611",
    "name": "Men's and boy's clothing and accessories stores"
  },
  {
    "code": "5621",
    "name": "Women's ready-to-wear stores"
  },
  {
    "code": "5631",
    "name": "Women's accessory and specialty shops"
  },
  {
    "code": "5641",
    "name": "Children's and infant's wear stores"
  },
  {
    "code": "5651",
    "name": "Family clothing stores"
  },
  {
    "code": "5655",
    "name": "Sports and riding apparel stores"
  },
  {
    "code": "5661",
    "name": "Shoe stores"
  },
  {
    "code": "5681",
    "name": "Furriers and fur shops"
  },
  {
    "code": "5691",
    "name": "Men's and women's clothing stores"
  },
  {
    "code": "5697",
    "name": "Tailors, seamstresses, mending and alterations"
  },
  {
    "code": "5698",
    "name": "Wig and toupee stores"
  },
  {
    "code": "5699",
    "name": "Miscellaneous apparel and accessory shops"
  },
  {
    "code": "5712",
    "name": "Furniture, home furnishings, and equipment stores, excepting appliances"
  },
  {
    "code": "5713",
    "name": "Floor covering stores"
  },
  {
    "code": "5714",
    "name": "Drapery, window covering, and upholstery stores"
  },
  {
    "code": "5718",
    "name": "Fireplace, fireplace screens and accessories stores"
  },
  {
    "code": "5719",
    "name": "Miscellaneous home furnishing specialty stores"
  },
  {
    "code": "5722",
    "name": "Household appliance stores"
  },
  {
    "code": "5732",
    "name": "Electronics stores"
  },
  {
    "code": "5733",
    "name": "Music stores - musical instruments, pianos, and sheet music"
  },
  {
    "code": "5734",
    "name": "Computer software stores"
  },
  {
    "code": "5735",
    "name": "Record stores"
  },
  {
    "code": "5811",
    "name": "Caterers"
  },
  {
    "code": "5812",
    "name": "Eating places & restaurants"
  },
  {
    "code": "5813",
    "name": "Drinking places - bars, taverns, nightclubs, cocktail lounges, and discotheques"
  },
  {
    "code": "5814",
    "name": "Fast food restaurants"
  },
  {
    "code": "5912",
    "name": "Drug stores and pharmacies"
  },
  {
    "code": "5921",
    "name": "Package stores - beer, wine, and liquor"
  },
  {
    "code": "5931",
    "name": "Used merchandise and secondhand stores"
  },
  {
    "code": "5932",
    "name": "Antique shops - sales, repairs, and restoration services"
  },
  {
    "code": "5933",
    "name": "Pawn shops"
  },
  {
    "code": "5935",
    "name": "Wrecking and salvage yards"
  },
  {
    "code": "5937",
    "name": "Antique reproductions"
  },
  {
    "code": "5940",
    "name": "Bicycle shops - sales and service"
  },
  {
    "code": "5941",
    "name": "Sporting goods stores"
  },
  {
    "code": "5942",
    "name": "Book stores"
  },
  {
    "code": "5943",
    "name": "Stationery stores, office and school supply stores"
  },
  {
    "code": "5944",
    "name": "Jewelry stores, watches, clocks, and silverware stores"
  },
  {
    "code": "5945",
    "name": "Hobby, toy, and game shops"
  },
  {
    "code": "5946",
    "name": "Camera and photographic supply stores"
  },
  {
    "code": "5947",
    "name": "Gift, card, novelty and souvenir shops"
  },
  {
    "code": "5948",
    "name": "Luggage and leather goods stores"
  },
  {
    "code": "5949",
    "name": "Sewing needlework, fabric, and piece goods stores"
  },
  {
    "code": "5950",
    "name": "Glassware / crystal stores"
  },
  {
    "code": "5960",
    "name": "Direct marketing - insurance services"
  },
  {
    "code": "5962",
    "name": "Direct marketing - travel-related arrangement services (high risk MCC)"
  },
  {
    "code": "5963",
    "name": "Door-to-door sales"
  },
  {
    "code": "5964",
    "name": "Direct marketing - catalog merchant"
  },
  {
    "code": "5965",
    "name": "Direct marketing - combination catalog and retail merchant"
  },
  {
    "code": "5966",
    "name": "Direct marketing - outbound telemarketing merchant (high risk MCC)"
  },
  {
    "code": "5967",
    "name": "Direct marketing - inbound tele-services merchant (high risk MCC)"
  },
  {
    "code": "5968",
    "name": "Direct marketing - continuity/subscription merch."
  },
  {
    "code": "5969",
    "name": "Direct marketing - other direct marketers (not elsewhere classified)"
  },
  {
    "code": "5970",
    "name": "Artists supply and craft shops"
  },
  {
    "code": "5971",
    "name": "Art dealers and galleries"
  },
  {
    "code": "5972",
    "name": "Stamp and coin stores"
  },
  {
    "code": "5973",
    "name": "Religious goods stores"
  },
  {
    "code": "5975",
    "name": "Hearing aids - sales, service, and supply"
  },
  {
    "code": "5976",
    "name": "Orthopedic goods - prosthetic devices"
  },
  {
    "code": "5977",
    "name": "Cosmetic stores"
  },
  {
    "code": "5978",
    "name": "Typewriters - sales, rentals, & service"
  },
  {
    "code": "5983",
    "name": "Fuel dealers - fuel oil, wood, coal, liquefied petroleum"
  },
  {
    "code": "5992",
    "name": "Florists"
  },
  {
    "code": "5993",
    "name": "Cigar stores and stands"
  },
  {
    "code": "5994",
    "name": "News dealers and newsstands"
  },
  {
    "code": "5995",
    "name": "Pet shops, pet foods and supplies stores"
  },
  {
    "code": "5996",
    "name": "Swimming pools - sales and service"
  },
  {
    "code": "5997",
    "name": "Electric razor stores"
  },
  {
    "code": "5998",
    "name": "Tent and awning shops"
  },
  {
    "code": "5999",
    "name": "Miscellaneous and specialty retail shops"
  },
  {
    "code": "6010",
    "name": "Financial institutions - manual cash disbursements"
  },
  {
    "code": "6011",
    "name": "Financial institutions - automated cash disbursements"
  },
  {
    "code": "6012",
    "name": "Financial institutions merchandise and services"
  },
  {
    "code": "6051",
    "name": "Non-financial institutions - foreign currency, money orders, and travelers cheques"
  },
  {
    "code": "6211",
    "name": "Security brokers / dealers"
  },
  {
    "code": "6300",
    "name": "Insurance sales, underwriting, & premiums"
  },
  {
    "code": "6381",
    "name": "Insurance premiums"
  },
  {
    "code": "6399",
    "name": "Insurance not elsewhere classified"
  },
  {
    "code": "6513",
    "name": "Real estate agents and managers - rentals"
  },
  {
    "code": "7011",
    "name": "Lodging - hotels, motels, resorts, and central reservation services (not elsewhere classified)"
  },
  {
    "code": "7012",
    "name": "Timeshares"
  },
  {
    "code": "7032",
    "name": "Sporting and recreational camps"
  },
  {
    "code": "7033",
    "name": "Trailer parks and campgrounds"
  },
  {
    "code": "7210",
    "name": "Laundry, cleaning, and garment services"
  },
  {
    "code": "7211",
    "name": "Laundries - family and commercial"
  },
  {
    "code": "7216",
    "name": "Dry cleaners"
  },
  {
    "code": "7217",
    "name": "Carpet and upholstery cleaning"
  },
  {
    "code": "7221",
    "name": "Photographic studios"
  },
  {
    "code": "7230",
    "name": "Beauty and barber shops"
  },
  {
    "code": "7251",
    "name": "Shoe repair shops, shoe shine parlors, and hat cleaning shops"
  },
  {
    "code": "7261",
    "name": "Funeral service and crematories"
  },
  {
    "code": "7273",
    "name": "Dating and escort services"
  },
  {
    "code": "7276",
    "name": "Tax preparation service"
  },
  {
    "code": "7277",
    "name": "Counseling services - debt, marriage, and personal"
  },
  {
    "code": "7278",
    "name": "Buying and shopping services and clubs"
  },
  {
    "code": "7296",
    "name": "Clothing rental - costumes, uniforms, and formal wear"
  },
  {
    "code": "7297",
    "name": "Massage parlors"
  },
  {
    "code": "7298",
    "name": "Health and beauty spas"
  },
  {
    "code": "7299",
    "name": "Miscellaneous personal services (not elsewhere classified)"
  },
  {
    "code": "7311",
    "name": "Advertising services"
  },
  {
    "code": "7321",
    "name": "Consumer credit reporting agencies"
  },
  {
    "code": "7332",
    "name": "Commercial photography, art, and graphics"
  },
  {
    "code": "7333",
    "name": "Commercial photography, art, and graphics"
  },
  {
    "code": "7338",
    "name": "Quick copy, reproduction and blueprinting services"
  },
  {
    "code": "7339",
    "name": "Stenographic and secretarial support"
  },
  {
    "code": "7342",
    "name": "Exterminating and disinfecting services"
  },
  {
    "code": "7349",
    "name": "Cleaning, maintenance, and janitorial services"
  },
  {
    "code": "7361",
    "name": "Employment agencies and temporary help services"
  },
  {
    "code": "7372",
    "name": "Computer programming, data processing, and integrated systems design services"
  },
  {
    "code": "7375",
    "name": "Information retrieval services"
  },
  {
    "code": "7379",
    "name": "Computer maintenance, repair, and services (not elsewhere classified)"
  },
  {
    "code": "7392",
    "name": "Management, consulting, and public relations services"
  },
  {
    "code": "7393",
    "name": "Detective agencies, protective services, and security services"
  },
  {
    "code": "7394",
    "name": "Equipment, tool, furniture, and appliance rental and leasing"
  },
  {
    "code": "7395",
    "name": "Photofinishing laboratories and photo developing"
  },
  {
    "code": "7399",
    "name": "Business services (not elsewhere classified)"
  },
  {
    "code": "7512",
    "name": "Automobile rental agency"
  },
  {
    "code": "7513",
    "name": "Truck and utility trailer rentals"
  },
  {
    "code": "7519",
    "name": "Motor home and recreational vehicle rentals"
  },
  {
    "code": "7523",
    "name": "Parking lots and garages"
  },
  {
    "code": "7531",
    "name": "Automotive body repair shops"
  },
  {
    "code": "7534",
    "name": "Tire retreading and repair shops"
  },
  {
    "code": "7535",
    "name": "Automotive paint shops"
  },
  {
    "code": "7538",
    "name": "Automotive service shops (non-dealer)"
  },
  {
    "code": "7542",
    "name": "Car washes"
  },
  {
    "code": "7549",
    "name": "Towing services"
  },
  {
    "code": "7622",
    "name": "Electronics repair shops"
  },
  {
    "code": "7623",
    "name": "Air conditioning and refrigeration repair shops"
  },
  {
    "code": "7629",
    "name": "Electrical and small appliance repair shops"
  },
  {
    "code": "7631",
    "name": "Watch, clock and jewelry repair"
  },
  {
    "code": "7641",
    "name": "Furniture - reupholstery, repair, and refinishing"
  },
  {
    "code": "7692",
    "name": "Welding services"
  },
  {
    "code": "7699",
    "name": "Miscellaneous repair shops and related services"
  },
  {
    "code": "7829",
    "name": "Motion picture and video tape production and distribution"
  },
  {
    "code": "7832",
    "name": "Motion picture theaters"
  },
  {
    "code": "7841",
    "name": "Video tape rental stores"
  },
  {
    "code": "7911",
    "name": "Dance halls, studios, and schools"
  },
  {
    "code": "7922",
    "name": "Theatrical producers and ticket agencies"
  },
  {
    "code": "7929",
    "name": "Bands, orchestras, and miscellaneous entertainers (not elsewhere classified)"
  },
  {
    "code": "7932",
    "name": "Billiard and pool establishments"
  },
  {
    "code": "7933",
    "name": "Bowling alleys"
  },
  {
    "code": "7941",
    "name": "Commercial sports, professional sports clubs, athletic fields, and sports promoters"
  },
  {
    "code": "7991",
    "name": "Tourist attractions and exhibits"
  },
  {
    "code": "7992",
    "name": "Public golf courses"
  },
  {
    "code": "7993",
    "name": "Video amusement game supplies"
  },
  {
    "code": "7994",
    "name": "Video game arcades / establishments"
  },
  {
    "code": "7995",
    "name": "Betting, including lottery tickets, casino gaming chips, off-track betting and wagers at race tracks"
  },
  {
    "code": "7996",
    "name": "Amusement parks, circuses, carnivals, and fortune tellers"
  },
  {
    "code": "7997",
    "name": "Membership clubs, country clubs, and private golf courses"
  },
  {
    "code": "7998",
    "name": "Aquariums, seaquariums, dolphinariums"
  },
  {
    "code": "7999",
    "name": "Recreation services (not elsewhere classified)"
  },
  {
    "code": "8011",
    "name": "Doctors and physicians (not elsewhere classified)"
  },
  {
    "code": "8021",
    "name": "Dentists and orthodontists"
  },
  {
    "code": "8031",
    "name": "Osteopaths"
  },
  {
    "code": "8041",
    "name": "Chiropractors"
  },
  {
    "code": "8042",
    "name": "Optometrists and ophthalmologists"
  },
  {
    "code": "8043",
    "name": "Opticians, optical goods, and eyeglasses"
  },
  {
    "code": "8049",
    "name": "Podiatrists and chiropodists"
  },
  {
    "code": "8050",
    "name": "Nursing and personal care facilities"
  },
  {
    "code": "8062",
    "name": "Hospitals"
  },
  {
    "code": "8071",
    "name": "Medical and dental laboratories"
  },
  {
    "code": "8099",
    "name": "Medical services and health practitioners (not elsewhere classified)"
  },
  {
    "code": "8111",
    "name": "Legal services and attorneys"
  },
  {
    "code": "8211",
    "name": "Elementary and secondary schools"
  },
  {
    "code": "8220",
    "name": "Colleges, universities, professional schools, and junior colleges"
  },
  {
    "code": "8241",
    "name": "Correspondence schools"
  },
  {
    "code": "8244",
    "name": "Business and secretarial schools"
  },
  {
    "code": "8249",
    "name": "Vocational and trade schools"
  },
  {
    "code": "8299",
    "name": "Schools and educational services (not elsewhere classified)"
  },
  {
    "code": "8351",
    "name": "Child care services"
  },
  {
    "code": "8398",
    "name": "Charitable and social service organizations"
  },
  {
    "code": "8641",
    "name": "Civic, social, and fraternal associations"
  },
  {
    "code": "8651",
    "name": "Political organizations"
  },
  {
    "code": "8661",
    "name": "Religious organizations"
  },
  {
    "code": "8675",
    "name": "Automobile associations"
  },
  {
    "code": "8699",
    "name": "Membership organizations (not elsewhere classified)"
  },
  {
    "code": "8734",
    "name": "Testing laboratories (non-medical testing)"
  },
  {
    "code": "8911",
    "name": "Architectural, engineering, and surveying services"
  },
  {
    "code": "8931",
    "name": "Accounting, auditing, and bookkeeping services"
  },
  {
    "code": "8999",
    "name": "Professional sevices (not elsewhere classified)"
  },
  {
    "code": "9000",
    "name": "ALL"
  },
  {
    "code": "9211",
    "name": "Court costs, including alimony and child support"
  },
  {
    "code": "9222",
    "name": "Fines"
  },
  {
    "code": "9223",
    "name": "Bail and bond payments"
  },
  {
    "code": "9311",
    "name": "Tax payments"
  },
  {
    "code": "9399",
    "name": "Government services (not elsewhere classified)"
  },
  {
    "code": "9402",
    "name": "Postal services - government only"
  },
  {
    "code": "9405",
    "name": "US federal government agencies or departments"
  }
];

// ─── Cities ───────────────────────────────────────────────────────────────────
// Shape: string[]  (sorted A-Z)
export const CITY_LIST = [
  "Abbottabad",
  "Adenzai",
  "Ahmadpur East",
  "Ahmadpur Sial",
  "Ahmedpur East",
  "Airport",
  "Akhagram Karo",
  "Ali Pur Chatta",
  "Alipur",
  "Allai",
  "Alpuri",
  "Ambar Utman Khel",
  "Aram Bagh",
  "Arif Wala",
  "Athara Hazari",
  "Attock",
  "Babuzai",
  "Badhber",
  "Badin",
  "Baffa Pakhal",
  "Bagh Maidan",
  "Bahawalnagar",
  "Bahawalpur",
  "Bahawalpur Saddar",
  "Baka Khel",
  "Bakrani",
  "Bala Kot",
  "Balambat",
  "Baldia Town",
  "Banda Daud Shah",
  "Bankad",
  "Bannu",
  "Bar Chamarkand",
  "Bara",
  "Barang",
  "Barawal",
  "Barikot",
  "Batagram",
  "Bataira / Kolai",
  "Bazar Zakha Khel",
  "Behrain",
  "Bettani",
  "Bhakkar",
  "Bhalwal",
  "Bhera",
  "Bhiria",
  "Bholari",
  "Bhowana",
  "Bin Qasim",
  "Birmil",
  "Bisham",
  "Bulri Shah Karim",
  "Buni",
  "Burewala",
  "Central Kurram",
  "Central Orakzai",
  "Chachro",
  "Chagharzai",
  "Chak Jhumra",
  "Chakesar",
  "Chakwal",
  "Chaman",
  "Chamber",
  "Chamkani",
  "Charbagh",
  "Charsadda",
  "Chaubara",
  "Chichawatni",
  "Chiniot",
  "Chishtian",
  "Chitral",
  "Choa Saidan Shah",
  "Chowk Sarwar Shaheed",
  "Chunian",
  "Civil Line",
  "Dadu",
  "Daggar",
  "Daharki",
  "Dahli",
  "Dajal",
  "Dara Adam Khel",
  "Daraban",
  "Darband",
  "Darya Khan",
  "Daska",
  "Dassu",
  "Datta Khel",
  "Daultala",
  "Daur  (2004)",
  "Daur Maira",
  "De-Excluded Area Rajanpur",
  "Depalpur",
  "Dera Ghazi Khan",
  "Dera Ismail Khan",
  "Dera Murad Jamali",
  "Digri",
  "Dina",
  "Dipalpur",
  "Diplo",
  "Dir",
  "Doaba",
  "Dokri",
  "Domel",
  "Dossali",
  "Drazanda",
  "Drosh",
  "Dunyapur",
  "Faisalabad",
  "Faisalabad Sadar",
  "Faiz Ganj",
  "Farooqabad",
  "Fateh Jang",
  "Ferozabad",
  "Ferozewala",
  "Ferozwala",
  "Fort Abbas",
  "Fort Salop",
  "Gadap Town",
  "Gadezai",
  "Gagra",
  "Gambat",
  "Garden",
  "Garhi Kapura",
  "Garhi Khairo",
  "Garhi Yasin",
  "Gharyum",
  "Ghazi",
  "Ghazni Khel",
  "Ghorabari",
  "Ghotki",
  "Ghulam Khan",
  "Gojra",
  "Gujar Khan",
  "Gujranwala",
  "Gujranwala Cantonment",
  "Gujranwala Saddar",
  "Gujrat",
  "Gulberg Town",
  "Gulshan-e-Iqbal",
  "Gulzar-e-Hijri",
  "Gumbat",
  "Hafizabad",
  "Hala",
  "Halim Zai",
  "Hangu",
  "Harban Basha",
  "Haripur",
  "Haroonabad",
  "Hasilpur",
  "Hassan Abdal",
  "Hassan Khel",
  "Haveli Lakha",
  "Havelian",
  "Hazro",
  "Hub",
  "Hussain Bux Mari",
  "Hyderabad",
  "Hyderabad City",
  "Ibrahim Hyderi",
  "Isakhel",
  "Islamabad",
  "Islamkot",
  "Ismail Zai",
  "Jacobabad",
  "Jahanian",
  "Jalalpur Jattan",
  "Jalalpur Pirwala",
  "Jallah jeem",
  "Jam Nawaz Ali",
  "Jampur",
  "Jampur Tribal Area",
  "Jamrud",
  "Jamshed Town",
  "Jand",
  "Jandola",
  "Jaranwala",
  "Jati",
  "Jatoi",
  "Jauharabad",
  "Jehangira",
  "Jhando Mari",
  "Jhang",
  "Jhelum",
  "Jhuddo",
  "Johi",
  "Judba",
  "K?moke",
  "Kabal",
  "Kabirwala",
  "Kahror Pacca",
  "Kahuta",
  "Kakki",
  "Kalkot",
  "Kallar Kahar",
  "Kallar Syedan",
  "Kaloi",
  "Kaloorkot",
  "Kamalia",
  "Kamber Ali Khan",
  "Kamoke",
  "Kandhkot",
  "Kandia",
  "Kandiaro",
  "Karachi",
  "Karak",
  "Karor Lal Esan",
  "Kashmore",
  "Kasur",
  "Katlang",
  "Kazi Ahmed",
  "Keamari Town",
  "Keti Bunder",
  "Khairpur",
  "Khairpur Nathan Shah",
  "Khairpur Tamewali",
  "Khal",
  "Khan Garh  (Khanpur)",
  "Khander Hassanzai",
  "Khanewal",
  "Khanpur",
  "Khanpur Katora",
  "Khar Bajaur",
  "Kharian",
  "Kharo Chan",
  "Khipro",
  "Khudu Khel",
  "Khushab",
  "Khuzdar",
  "Khwaza Khela",
  "Kingri",
  "Koh-e-Suleman",
  "Kohat",
  "Korangi Town",
  "Kot Abdul Malik",
  "Kot Addu",
  "Kot Chutta",
  "Kot Diji",
  "Kot Ghulam Muhammad",
  "Kot Momin",
  "Kot Radha Kishan",
  "Kotli Sattian",
  "Kotri",
  "Kulachi",
  "Kunjah",
  "Kunri",
  "Lachi",
  "Ladha",
  "Lahor",
  "Lahore",
  "Lahore Cantonment",
  "Lakhi",
  "Lakki Marwat",
  "Lal Qilla",
  "Lala Musa",
  "Lalian",
  "Landhi Town",
  "Landi Kotal",
  "Lar Jam",
  "Larkana",
  "Latifabad",
  "Lawa",
  "Layyah",
  "Liaqatpur",
  "Liaquatabad Town",
  "Lodhran",
  "Lora",
  "Lower Kurram",
  "Lower Orakzai",
  "Lower Tanawal",
  "Ludhewala Waraich",
  "Lyari Town",
  "Mailsi",
  "Makhuzai",
  "Makin",
  "Malakwal",
  "Mamund",
  "Mandanr",
  "Mandi Bahauddin",
  "Mandi Shah Jeewna",
  "Manghopir",
  "Manjhand",
  "Mankera",
  "Mansehra",
  "Mardan",
  "Maripur",
  "Martung",
  "Mastuj",
  "Mathra",
  "Matiari",
  "Matli",
  "Matta",
  "Mehar",
  "Mehrabpur",
  "Mian Channu",
  "Mianwali",
  "Minchinabad",
  "Mingora",
  "Mir Ali",
  "Miran Shah",
  "Mirokhan",
  "Mirpur",
  "Mirpur Bathoro",
  "Mirpur Khas",
  "Mirpur Mathelo",
  "Mirpur Sakro",
  "Miryan",
  "Mithi",
  "Model Colony",
  "Model Town",
  "Mominabad",
  "Moro",
  "Muhammadpur",
  "Mula Gori",
  "Mulkoh",
  "Multan",
  "Multan Khurd",
  "Multan Saddar",
  "Munda",
  "Murad Memon Goth",
  "Muridke",
  "Murree",
  "Muzaffarabad",
  "Muzaffargarh",
  "Nagarparkar",
  "Nankana Sahib",
  "Nara",
  "Narowal",
  "Nasirabad",
  "Naushahro Feroze",
  "Naushera (Wadi-e-Soon)",
  "Nawabshah  (1907)",
  "Nawabshah (Benazirabad)",
  "Nawagai",
  "Nazimabad",
  "Nehag Dara",
  "New Karachi Town",
  "New Sukkur",
  "Noorpur Thal",
  "North Nazimabad Town",
  "Nowshera",
  "Nowshera Virkan",
  "Oghi",
  "Okara",
  "Orangi Town",
  "Pabbi",
  "Paharpur",
  "Painda Cheena",
  "Pakpattan",
  "Palas",
  "Paniala",
  "Panjgur",
  "Pano Akil",
  "Paroa",
  "Pasrur",
  "Pattan",
  "Pattoki",
  "Peshawar",
  "Peshawar City",
  "Peshtakhara",
  "Phalia",
  "Phool Nagar",
  "Pind Dadan Khan",
  "Pindi Bhattian",
  "Pindi Gheb",
  "Pindiali",
  "Piplan",
  "Pirmahal",
  "Pishin",
  "Pithoro",
  "Pran Ghar",
  "Puran",
  "Qambar",
  "Qasimabad",
  "Quaidabad",
  "Qubo Saeed Khan",
  "Quetta",
  "Rahim Yar Khan",
  "Raiwind",
  "Rajanpur",
  "Ratodero",
  "Rawalpindi",
  "Razar",
  "Razmak",
  "Renala Khurd",
  "Rohri",
  "Rojhan",
  "Rustam",
  "S.I.T.E. Town",
  "Saddar Town",
  "Sadiqabad",
  "Saeedabad",
  "Safdarabad",
  "Safi",
  "Sahib Abad",
  "Sahiwal",
  "Sakrand  (1858)",
  "Salarzai",
  "Salehpat",
  "Sam Ranizai",
  "Samar Bagh",
  "Samaro",
  "Sambrial",
  "Samundri",
  "Sanghar",
  "Sangla Hill",
  "Sarai Alamgir",
  "Sararogha",
  "Sargodha",
  "Sari Naurang",
  "Sarwakai",
  "Sehwan",
  "Seo",
  "Shabqadar",
  "Shah Alam",
  "Shah Bandar",
  "Shah Faisal Town",
  "Shah Kot",
  "Shah Mureed",
  "Shahdadkot",
  "Shahdadpur",
  "Shaheed Fazil Rahu",
  "Shahpur",
  "Shakai",
  "Shakargarh",
  "Shaktoi",
  "Shalimar",
  "Sharak Pur",
  "Sharingal",
  "Shawal",
  "Sheikhupura",
  "Shewa",
  "Shikarpur",
  "Shorkot",
  "Shujabad",
  "Sialkot",
  "Sijawal Junejo",
  "Sillanwali",
  "Sindhri",
  "Sinjhoro",
  "Sobho Dero",
  "Sohawa",
  "Spinwam",
  "Sujawal",
  "Sukkur",
  "Swabi",
  "Swat Ranizai",
  "Takht Bhai",
  "Takht-e-Nasrati",
  "Talagang",
  "Talhar",
  "Tall",
  "Tanawal",
  "Tandlianwala",
  "Tando Adam",
  "Tando Adam Khan",
  "Tando Allahyar",
  "Tando Bago",
  "Tando Ghulam Hyder",
  "Tando Muhammad Khan",
  "Tangi",
  "Tangwani",
  "Tank",
  "Taunsa",
  "Taxila",
  "Thana Baizai",
  "Thana Bulla Khan",
  "Thari Mirwah",
  "Thatta",
  "Thul",
  "Tiarza",
  "Timergara",
  "Toba Tek Singh",
  "Toi Khulla",
  "Tonsa",
  "Topi",
  "Torkoh",
  "Turbat",
  "Ubauro",
  "Umerkot",
  "Upper Kurram",
  "Upper Mohmand",
  "Upper Orakzai",
  "Utman Khel",
  "Vehari",
  "Wah Cantonment",
  "Wahova",
  "Wana",
  "Warah",
  "Wari",
  "Wazir",
  "Wazirabad",
  "Yake Ghund",
  "Yazman",
  "Zafarwal"
];
export const TERMINAL_LOCATION = {
  PROVINCES: [
    "Punjab",
    "Sindh",
    "Khyber Pakhtunkhwa",
    "Balochistan",
    "Islamabad Capital Territory",
    "Gilgit-Baltistan",
    "Azad Jammu and Kashmir",
  ],
};